import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEvent } from "@/lib/event-context";
import { moduleRegistry } from "@/components/modules/registry";
import type { ModuleConfigMap, ModuleId } from "@/lib/event-schema";
import { NotFoundView } from "@/routes/NotFound";

export function EventModulePage() {
  const event = useEvent();
  const { module } = useParams<{ module: string }>();
  const moduleId = module as ModuleId;
  const config = event.modules[moduleId];
  const entry = moduleId ? moduleRegistry[moduleId] : undefined;

  if (!entry || !config || !config.enabled) {
    return <NotFoundView />;
  }

  const Component = entry.Public as React.ComponentType<{
    config: ModuleConfigMap[ModuleId];
    event: typeof event;
  }>;

  return (
    <div className="pt-6">
      <div className="mx-auto max-w-6xl px-5 sm:px-6 lg:px-8">
        <Link
          to={`/${event.slug}`}
          className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs uppercase tracking-[0.18em] text-muted hover:text-accent transition-colors"
        >
          <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.75} />
          Back to overview
        </Link>
      </div>
      <Component config={config} event={event} />
    </div>
  );
}
